import React, { memo } from "react";
import {
  StyledAvatarCardContainer,
  StyledAvatarCard,
  StyledAvatarCardText,
  StyledAvatar
} from "./avatar-card.styles";
import HoursWorked from "../HoursWorked/hours-worked";

const AvatarCard = ({
  member,
  hoursCompleted,
  isEmptyCell,
  isProviderScheduler,
  openShiftModal,
  memberIndex
}) => {
  const { firstName, lastName, photo, isLimitedHours, limitedHours } = member;

  return (
    <StyledAvatarCardContainer onClick={() => openShiftModal(memberIndex)}>
      {!isEmptyCell && <StyledAvatar alt={firstName} src={photo} />}
      <StyledAvatarCard>
        <StyledAvatarCardText>
          {firstName} {lastName}
        </StyledAvatarCardText>
        {isProviderScheduler && (
          <HoursWorked
            isLimitedHours={isLimitedHours}
            limitedHours={limitedHours}
            hoursCompleted={hoursCompleted}
          />
        )}
      </StyledAvatarCard>
    </StyledAvatarCardContainer>
  );
};

export default memo(AvatarCard);
